import { useEffect, useCallback } from "react";
import { X, CaretLeft, CaretRight } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const fullUrl = (p) => `${BACKEND_URL}/api/files/${p.path}`;

export function PhotoLightbox({ photos, index, onClose, onNavigate }) {
  const count = photos?.length || 0;
  const go = useCallback(
    (d) => onNavigate((index + d + count) % count),
    [index, count, onNavigate]
  );

  useEffect(() => {
    const h = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowRight" && count > 1) go(1);
      else if (e.key === "ArrowLeft" && count > 1) go(-1);
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [go, onClose, count]);

  if (!photos || index == null || !photos[index]) return null;
  const p = photos[index];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm animate-in fade-in duration-150"
      data-testid="photo-lightbox"
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white/80 hover:text-white p-2 rounded-full hover:bg-white/10 transition-colors"
        onClick={onClose}
        aria-label="Закрити"
        data-testid="lightbox-close"
      >
        <X size={28} weight="bold" />
      </button>

      {count > 1 && (
        <button
          className="absolute left-3 sm:left-6 text-white/80 hover:text-white p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          onClick={(e) => { e.stopPropagation(); go(-1); }}
          aria-label="Попереднє"
          data-testid="lightbox-prev"
        >
          <CaretLeft size={28} weight="bold" />
        </button>
      )}

      <img
        src={fullUrl(p)}
        alt={p.filename || "фото"}
        className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg shadow-2xl select-none"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-image"
      />

      {count > 1 && (
        <button
          className="absolute right-3 sm:right-6 text-white/80 hover:text-white p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          onClick={(e) => { e.stopPropagation(); go(1); }}
          aria-label="Наступне"
          data-testid="lightbox-next"
        >
          <CaretRight size={28} weight="bold" />
        </button>
      )}

      {count > 1 && (
        <div
          className="absolute bottom-5 left-1/2 -translate-x-1/2 text-white/90 text-sm font-medium px-3 py-1 rounded-full bg-black/50"
          data-testid="lightbox-counter"
        >
          {index + 1} / {count}
        </div>
      )}
    </div>
  );
}

export default PhotoLightbox;
